import { i18n } from '../../i18n/i18n.js';
import '../styles/main.scss';
import '../styles/pages/home.scss';
import { componentLoader } from './components/loadComponents.js';
import { sectionReveal } from './utils/scrollReveal.js';
import { setupNavigation } from './utils/navMenu.js';
import { initProductCarousel } from './utils/productCarousel.js';
import { initMarquee } from './utils/marquee.js';
import { initROICalculator } from './components/roiCalculator.js';
import { initAccordion } from './components/accordion.js';

const ensureHelveticaNeue = () => {
  if (document.querySelector('link[data-font="helvetica-neue"]')) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.cdnfonts.com/css/helvetica-neue-9';
  link.setAttribute('data-font', 'helvetica-neue');
  document.head.appendChild(link);
};

ensureHelveticaNeue();

// 确保全局可以访问i18n
window.i18n = i18n;

// DOMContentLoaded 事件处理
document.addEventListener('DOMContentLoaded', async () => {
  // 加载页面组件
  await componentLoader.loadAllComponents();
  
  // 初始化多语言功能
  await i18n.init();
  
  // 设置导航（移动端菜单、滚动锁、活跃态）
  setupNavigation();

  // ===== Home: Brand marquee =====
  initMarquee('.brand-marquee__track', {
    speed: 0.4,
    autoFill: true,
  });

  // ===== Home: ROI calculator =====
  initROICalculator({
    rentals: {
      id: 'roi-rentals',
      labelId: 'roi-rentals-label',
      min: 1,
      max: 50,
      step: 1,
      default: 15,
    },
    price: {
      id: 'roi-price',
      labelId: 'roi-price-label',
      min: 0,
      max: 8,
      step: 0.5,
      default: 3.5,
    },
    stations: {
      id: 'roi-number',
      labelId: 'roi-number-label',
      min: 1,
      max: 100,
      step: 1,
      default: 3,
    },
    revenueId: 'roi-revenue',
    daysPerMonth: 30,
  });

  // ===== Home: Testimonials carousel =====
  // 全局 section 滚动显现
  const sections = document.querySelectorAll('section');
  sectionReveal.reveal(Array.from(sections));

  // ===== Products: simple slider =====
  initProductCarousel('.product-card__track');

  // ===== Home: FAQ accordion =====
  initAccordion('.accordion', {
    multiple: false, // 只允许一个展开
    defaultOpen: 0,  // 默认展开第一项
  });

});
